(function () {
  // Nieuwe flow op de productkaarten: +/- past alleen het weergegeven aantal aan
  // (we nemen de knoppen zelf volledig over, los van de interne logica van het thema).
  // Er gebeurt GEEN automatische winkelwagen-update meer bij het klikken op +/-.
  // Pas bij een klik op de oranje winkelwagenknop wordt het gekozen aantal echt
  // toegevoegd aan de winkelwagen.

  function getToast(card) {
    var footer = card.querySelector('.card-footer');
    if (!footer) return null;

    var toast = footer.querySelector('.card-quickadd-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'card-quickadd-toast';
      toast.setAttribute('role', 'status');
      footer.appendChild(toast);
    }
    return toast;
  }

  function showToast(card, message) {
    var toast = getToast(card);
    if (!toast) return;

    toast.textContent = message;
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');

    clearTimeout(toast._stromoHideTimer);
    toast._stromoHideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 1600);
  }

  function getStep(input) {
    var step = parseInt(input.getAttribute('step'), 10);
    return isNaN(step) || step < 1 ? 1 : step;
  }

  function getMin(input) {
    var min = parseInt(input.getAttribute('min'), 10);
    return isNaN(min) ? 0 : min;
  }

  function getMax(input) {
    var max = parseInt(input.getAttribute('max'), 10);
    return isNaN(max) ? null : max;
  }

  // Neemt de +/- knoppen op productkaarten volledig over: past alleen het getal aan,
  // zonder de winkelwagen aan te roepen.
  function handleStepperClick(event) {
    var button = event.target.closest(
      '.card-product .quantity-input-plus, .card-product .quantity-input-minus'
    );
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var card = button.closest('.card-product');
    if (!card) return;
    var input = card.querySelector('.quantity-input-field');
    if (!input) return;

    var isPlus = button.classList.contains('quantity-input-plus');
    var step = getStep(input);
    var min = getMin(input);
    var max = getMax(input);
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = min;

    var next = isPlus ? current + step : current - step;
    if (next < min) next = min;
    if (max !== null && next > max) next = max;

    input.value = next;
  }

  // Blokkeert dat een handmatig getypt aantal (via blur/'change') alsnog automatisch
  // wordt toegevoegd. Alleen onze eigen, expliciet gemarkeerde 'change' (afkomstig van
  // de winkelwagenknop) mag door naar het thema's eigen winkelwagen-mechanisme.
  function blockAutoSubmit(event) {
    if (event.detail && event.detail.stromoForceSubmit) return;

    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('quantity-input-field')) return;
    if (!input.closest('.card-product')) return;

    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  function handleCartButtonClick(event) {
    var button = event.target.closest('.card-quickadd-cart-button');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var card = button.closest('.card-product');
    if (!card) return;

    var input = card.querySelector('.quantity-input-field');
    if (!input) return;

    var currentValue = parseInt(input.value, 10);
    if (isNaN(currentValue) || currentValue < 1) {
      var min = getMin(input);
      input.value = min > 1 ? min : 1;
    }

    // De enige 'change' die echt naar de winkelwagen mag: gemarkeerd zodat
    // blockAutoSubmit hem doorlaat naar het thema's eigen (bewezen werkende)
    // /cart/update-mechanisme.
    input.dispatchEvent(
      new CustomEvent('change', { bubbles: true, detail: { stromoForceSubmit: true } })
    );

    showToast(card, 'Toegevoegd aan winkelwagen');
  }

  document.addEventListener(
    'click',
    function (event) {
      handleStepperClick(event);
      handleCartButtonClick(event);
    },
    true
  );

  document.addEventListener('change', blockAutoSubmit, true);
})();
